import {
  all,
  call,
  put,
  select,
  takeEvery
}                       from 'redux-saga/effects';
import service          from '../../services';
import { getBookmarks } from "../bookmarks/actions";


function* deleteBookmarkSaga(action) {
  const {ids, pane} = action;
  const {token} = yield select(state => state.API);

  try {
    yield all(ids.map(id => call(() => service.deleteBookmark(token, id))));
  } catch (e) {

  } finally {
    yield put(getBookmarks(pane));
  }
}


export default function* () {
  yield takeEvery('deleteBookmark', deleteBookmarkSaga)
}